import { TaskTypeId } from "@sp-crm/core";
import { useGetTaskTypesQuery } from "generated/graphql";
import React from "react";
import { stableQueryOptions } from "util/requests";

interface NamedActivityType {
    id: TaskTypeId;
    name: string;
}

export const activityTypeName = (
    activityTypes: NamedActivityType[],
    activityTypeId: TaskTypeId | null,
): string | null => {
    if (!activityTypeId) {
        return null;
    }
    return (
        activityTypes.find(activityType => activityType.id === activityTypeId)?.name ??
        null
    );
};

export const useActivityTypeName = (activityTypeId: TaskTypeId | null): string | null => {
    const query = useGetTaskTypesQuery({}, stableQueryOptions());
    return activityTypeName(query.data?.getTaskTypes ?? [], activityTypeId);
};

export const ActivityTypeLabel: React.FC<{ activityTypeId: TaskTypeId | null }> = ({
    activityTypeId,
}) => {
    const name = useActivityTypeName(activityTypeId);
    if (!name) {
        return null;
    }
    return (
        <div className="text-sm text-gray-500">
            Activity type: <span className="font-medium text-gray-700">{name}</span>
        </div>
    );
};
